import { Button } from '@crowdex/ui/components/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@crowdex/ui/components/dialog';
import { Input } from '@crowdex/ui/components/input';

type CreateBranchDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  baseBranch: string | null;
  branchName: string;
  onBranchNameChange: (value: string) => void;
  error: string | null;
  onCreate: () => void;
  preview: boolean;
};

/** Dialog to name and create a new git branch from the current one. */
export function CreateBranchDialog({
  open,
  onOpenChange,
  baseBranch,
  branchName,
  onBranchNameChange,
  error,
  onCreate,
  preview,
}: CreateBranchDialogProps) {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Create a branch</DialogTitle>
          <DialogDescription>
            The new branch will start from {baseBranch ?? 'the current branch'}.
          </DialogDescription>
        </DialogHeader>
        <Input
          className="h-control-lg rounded-lg"
          onChange={(event) => onBranchNameChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') onCreate();
          }}
          placeholder="feature/my-branch"
          value={branchName}
        />
        {error !== null && <p className="text-destructive text-sm">{error}</p>}
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)} variant="ghost">
            Cancel
          </Button>
          <Button disabled={branchName.trim().length === 0 || preview} onClick={() => onCreate()}>
            Create Branch
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
